"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertaPortal = void 0;
var react_1 = __importStar(require("react"));
var __1 = require("../../..");
var AlertaModal_1 = require("../AlertaModal/AlertaModal");
var estilosAlertaPortal = require("./AlertaPortal.module.scss");
var AlertaPortal = (0, react_1.memo)(function (_a) {
    var alerts = _a.alerts, repositorio = _a.repositorio, removerAlerta = _a.removerAlerta;
    var _b = (0, react_1.useState)({}), modaisAbertos = _b[0], setModaisAbertos = _b[1];
    var toggleModal = function (alerta, isOpen) {
        setModaisAbertos(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[alerta] = isOpen, _a)));
        });
    };
    return (react_1.default.createElement("div", { className: estilosAlertaPortal["alert-container"], id: "alertaPortal" }, alerts.map(function (alerta) { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: estilosAlertaPortal["alert-componente"], id: "alertaComponente" },
            react_1.default.createElement(__1.Alerta, __assign({ key: alerta.id }, alerta, { esconderTextoExtenso: true, limiteLinhasExibicao: 3, alinhamentoTexto: "start", onVerMais: alerta.onVerMais
                    ? function () { return toggleModal(alerta.id, true); }
                    : undefined, onFechar: function () { var _a; return removerAlerta((_a = alerta.id) !== null && _a !== void 0 ? _a : ""); }, pausarTimeout: modaisAbertos[alerta.id] }))),
        react_1.default.createElement(AlertaModal_1.AlertaModal, { alerta: alerta, isOpen: modaisAbertos[alerta.id], onClose: function () { return toggleModal(alerta.id, false); }, repositorio: repositorio }))); })));
});
exports.AlertaPortal = AlertaPortal;
